import { render } from "./validateIdCard.vue?vue&type=template&id=28173db1&scoped=true"
import script from "./validateIdCard.vue?vue&type=script&lang=js"
export * from "./validateIdCard.vue?vue&type=script&lang=js"

import "./validateIdCard.vue?vue&type=style&index=0&id=28173db1&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28173db1"]])

export default __exports__